import React, { useEffect, useMemo } from 'react';
import useData from '../../hooks/useData';
import { getPosts } from '../../services/blogApi';
import Alert from '../shared/Alert';
import Loading from '../shared/Loading';
import Paginator from '../shared/Paginator';
import BlogCard from './BlogCard';

const ITEMS_PER_PAGE = 6;

const PostsContainer = ({ categorySelected, searchTerm }) => {
  const { rows, page, count, isError, isLoading, getDataNextPage, getDataWithFilters, resetFilters } = useData({
    name: 'posts',
    getAllAnyWithFilters: getPosts,
    initRowsPerPage: ITEMS_PER_PAGE,
    orderBy: [
      { type: 'desc', by: 'IsFeatured' },
      { type: 'desc', by: 'CreatedAt' },
    ],
    isEnabled: false,
  });

  useEffect(() => {
    filterData();
    // eslint-disable-next-line
  }, [categorySelected]);

  const filterData = () => {
    if (categorySelected === 'All') {
      resetFilters();
    } else {
      getDataWithFilters({ default: `$filter=Category eq '${categorySelected}'` });
    }
  };

  const filteredPosts = useMemo(() => {
    if (!searchTerm || !searchTerm.trim()) return rows;

    return rows.filter((post) =>
      post.Title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.ShortDescription.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [rows, searchTerm]);

  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : isError ? (
        <Alert open={isError} severity="warning" message="Error loading data, try again later" />
      ) : filteredPosts.length > 0 ? (
        <>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-4 mb-4">
            {filteredPosts.map((post) => (
              <BlogCard key={post.Id} {...post} />
            ))}
          </div>
          {count > ITEMS_PER_PAGE && (
            <Paginator
              count={count}
              lastPage={(page + 1) * ITEMS_PER_PAGE}
              page={page}
              handleChangePage={getDataNextPage}
            />
          )}
        </>
      ) : (
        <Alert open={true} message="There are no posts at this time" severity="info" />
      )}
    </div>
  );
};

export default PostsContainer;